"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = Cell;

var _react = _interopRequireDefault(require("react"));

function Cell(_ref) {
  var content = _ref.content,
      header = _ref.header;
  var cellMarkup = header ? _react["default"].createElement("th", null, content) : _react["default"].createElement("td", null, content);
  return cellMarkup;
}